// Styled Components
import styled from "styled-components";

const InfoThreeUzi = (props) => {
  return (
    <Wrapper animateFirst={props.animateFirst}>
      {!props.video && <img src={props.img} alt="" className="img" />}
      {props.video && (
        <video
          autoPlay={true}
          loop={true}
          playsInline={true}
          muted
          className="img"
        >
          <source src={props.img} type="video/mp4" />
        </video>
      )}
      {/* <div className="specs">
        <div className="spec spec-top">
          <p className="header">{props.spec_1_header}</p>
          <p className="info">{props.spec_1_info}</p>
        </div>
        <div className="spec spec-top">
          <p className="header">{props.spec_2_header}</p>
          <p className="info">{props.spec_2_info}</p>
        </div>
        <div className="spec spec-bottom">
          <p className="header">{props.spec_3_header}</p>
          <p className="info">{props.spec_3_info}</p>
        </div>
        <div className="spec spec-bottom">
          <p className="header">{props.spec_4_header}</p>
          <p className="info">{props.spec_4_info}</p>
        </div>
      </div> */}
    </Wrapper>
  );
};

export default InfoThreeUzi;

const Wrapper = styled.div`
  .img {
    //
    width: 400px;
    @media only screen and (max-width: 1600px) {
      width: 350px;
    }
    @media only screen and (max-width: 1400px) {
      width: 325px;
    }
    @media only screen and (max-width: 1300px) {
      width: 300px;
    }
    @media only screen and (max-width: 1250px) {
      width: 400px;
    }
    @media only screen and (max-width: 475px) {
      width: 100%;
    }
    //
  }

  display: flex;
  flex-direction: column;

  .specs {
    display: grid;

    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;

    //
    @media only screen and (max-width: 1600px) {
      width: 350px;
    }
    @media only screen and (max-width: 1400px) {
      width: 325px;
    }
    @media only screen and (max-width: 1300px) {
      width: 300px;
    }
    @media only screen and (max-width: 1250px) {
      width: 400px;
    }
    @media only screen and (max-width: 475px) {
      width: 100%;
    }
    //

    .spec {
      padding: 5px;
      background-color: #3e3e3e;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      outline: 1px solid black;

      &-top {
        animation: ${(props) =>
          props.animateFirst && "spec-background 10s infinite"};
      }

      &-bottom {
        animation: ${(props) =>
          !props.animateFirst && "spec-background 10s infinite"};
      }

      .header {
        font-size: 0.9rem;

        font-family: interstate, sans-serif;
        font-weight: 700;
      }

      .info {
        font-size: 1.25rem;

        font-family: acumin-pro-wide, sans-serif;
      }
    }
  }

  @keyframes spec-background {
    0% {
      background-color: #3e3e3e;
    }

    50% {
      background-color: #8f8f8f;
    }
    100% {
      background-color: #3e3e3e;
    }
  }
`;
